<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Usuarios
            </h2>
            <small class="title-description">
                Gestion de usuarios
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedUser!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllUsers()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>

<form class="card mt-3" [formGroup]="form">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-center flex-column flex-sm-row">

            <h2 class="m-0 mr-2">
                {{selectedUser&&selectedUser.usuario_aplicativo ?
                selectedUser.usuario_aplicativo : "Crear"}}
            </h2>
            <small class="title-description">
                {{selectedUser&&selectedUser.nombre_usuario ?
                selectedUser.nombre_usuario : "Digite todos los campos"}}
            </small>
        </div>
    </div>

    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-12">
            <mat-label>Nombre completo del usuario</mat-label>
            <input matInput formControlName="nombre_usuario"
                (input)="form.get('nombre_usuario')?.setValue(form.get('nombre_usuario')?.value.toUpperCase())"
                type="text" [maxlength]="40">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Usuario aplicativo</mat-label>
            <input matInput formControlName="usuario_aplicativo"
                (input)="ignoreSpecialCharactersVoid('usuario_aplicativo',form.get('usuario_aplicativo')?.value.toUpperCase())"
                type="text" [maxlength]="30">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Clave</mat-label>
            <input matInput formControlName="clave_encriptada" type="password" [maxlength]="20" [minlength]="6">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Correo electrónico</mat-label>
            <input matInput formControlName="correo"
                (input)="form.get('correo')?.setValue(form.get('correo')?.value.toUpperCase())" type="email"
                [maxlength]="200">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Celular</mat-label>
            <input matInput formControlName="celular" (input)="ignoreLettersVoid('celular',form.get('celular')?.value)"
                type="number" [maxlength]="15">
        </mat-form-field>
        <!-- <mat-accordion class="w-100">
            <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Otra configuración del usuario
                    </mat-panel-title>
                </mat-expansion-panel-header> -->

        <!-- <div class="row"> -->
        <!-- <mat-form-field appearance="fill" class="col-12 col-md-6">
                        <mat-label>Fecha de nacimiento</mat-label>
                        <input matInput formControlName="fecha_nacimiento"
                            (input)="form.get('fecha_nacimiento')?.setValue(form.get('fecha_nacimiento')?.value.toUpperCase())"
                            type="date">
                    </mat-form-field> -->
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Agencia de trabajo</mat-label>
            <mat-select formControlName="c_age_trabajo">
                <mat-option [value]="agencia.c_age" *ngFor="let agencia of agencies">{{agencia.nom}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="estado">
                <mat-option [value]="'A'">Activo</mat-option>
                <mat-option [value]="'I'">Inactivo</mat-option>
            </mat-select>
        </mat-form-field>
        <!-- </div>
            </mat-expansion-panel>
        </mat-accordion> -->



    </div>

    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <a mat-flat-button class="btn" type="button" *ngIf="selectedUser!=undefined" (click)="openRolesDialog()">
            Ver roles del usuario
        </a>
        <button mat-flat-button type="button" (click)="create()" class="btn btn-secondary"
            [ngClass]="{'btn-primary': selectedUser==undefined,'btn-secondary': selectedUser!=undefined}">Crear
            nuevo</button>
        <button mat-flat-button class="btn btn-primary" type="button" *ngIf="selectedUser!=undefined"
            (click)="modify()">Modificar</button>

    </div>
</form>
<div class="shadow mt-3" *ngIf="users.length>0">
    <coky-table [title]="'Listado de usuarios'" [description]="'Seleccione un registro para modificar'" [data]="users"
        (clickRow)="selectUser($event)" [multipleSelection]="false">
    </coky-table>
</div>

<div class="card mt-3" *ngIf="users.length==0">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                No hay usuarios
            </h2>
            <small class="title-description">
                No se ha creado ningún usuario todavía.
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedUser!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllUsers()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>